import './styles.scss';
import UserAvatarIcon from '../icons/UserAvatarIcon';
import { useAuth } from 'core/contexts/authContext';
import TeammateLi from '../TeammateLi';

const UserWithTeammatesSidebarSection = () => {
  const { user, teammates, userTeam } = useAuth();

  if (!user || !userTeam) {
    return null;
  }

  return (
    <>
      <section className="user-profile">
        <div className="avatar-container">
          {user.photo_url ? (
            <img src={user.photo_url} alt="User avatar" className="avatar" />
          ) : (
            <UserAvatarIcon className="avatar-icon" />
          )}
        </div>
        <h2 className="participant-name">
          {user.firstname} {user.lastname}
        </h2>
        <h3 className="team-name">{userTeam.team_name}</h3>
      </section>

      <section className="teammates">
        <h3>MY TEAMMATES</h3>
        <ul className="teammates-list">
          {teammates.map(teammate => (
            <TeammateLi key={teammate.id} teammate={teammate} />
          ))}
        </ul>
      </section>
    </>
  );
};

export default UserWithTeammatesSidebarSection;
